function initBenefitsListDrag() {
  for (const list of document.querySelectorAll('.benefits-list')) {
    const maxScroll = list.scrollWidth - list.clientWidth;
    if (maxScroll <= 0) continue;

    let isDown = false;
    let startX;
    let scrollLeft;
    let hasDragged = false;

    list.addEventListener('mousedown', (e) => {
      isDown = true;
      hasDragged = false;
      startX = e.pageX;
      scrollLeft = list.scrollLeft;
      list.classList.add('benefits-list_dragging');
    });

    list.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const walk = e.pageX - startX;
      if (Math.abs(walk) > 3) hasDragged = true;
      list.scrollLeft = scrollLeft - walk;
    });

    list.addEventListener('mouseup', () => {
      isDown = false;
      list.classList.remove('benefits-list_dragging');
    });

    list.addEventListener('mouseleave', () => {
      isDown = false;
      list.classList.remove('benefits-list_dragging');
    });

    list.addEventListener('click', (e) => {
      if (hasDragged) e.preventDefault();
    }, true);
  }
}

document.addEventListener('DOMContentLoaded', initBenefitsListDrag);